import React from "react";

import "./_appStyle.scss";
// SCREDP-112 - Prevent multiple submissions while save request operations are executing
import { LoaderWrapper } from "./styled";
import { ProgressSpinner } from 'primereact/progressspinner';

// SCREDP-112 - Prevent multiple submissions while save request operations are executing
const FullScreenLoader = () => {
   return (
      <LoaderWrapper>
         <div 
            aria-busy="true"
            style={{
               textAlign: "center",
               display: "flex", 
               zIndex : 10000,
               alignItems: 'center',
               justifyContent: 'center',
               width: "100%",
               height: "100%"
            }}
         >
            <div
               style={{
                  color: "white"
               }}
            >
               <ProgressSpinner 
                  style={{
                     zIndex : 10001,
                     opacity: 1
                  }} 
                  strokeWidth="8" 
                  animationDuration=".5s" 
               />
            </div>
         </div> 
         <div
            aria-busy="true"
            className="modal-backdrop show"
            style={{
               textAlign: "center",
               display: "flex", 
               zIndex : 9999,
               alignItems: 'center',
               justifyContent: 'center',
               width: "100%",
               height: "100%",
               
            }}
         >
         </div> 
      </LoaderWrapper>
   );
};

export default FullScreenLoader;
